import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-fluid p-formgrid p-grid"
}
const _hoisted_2 = { class: "p-field p-col-6  p-mt-5" }
const _hoisted_3 = { class: "p-float-label " }
const _hoisted_4 = {
  for: "code",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-6 p-mt-5" }
const _hoisted_6 = { class: "p-float-label " }
const _hoisted_7 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-col-12" }
const _hoisted_9 = { class: "p-float-label p-mb-2" }
const _hoisted_10 = {
  for: "descr",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.workspaceNewFolderDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('workspace.myRepository.newFolderTitle')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.createFolder,
          disabled: _ctx.buttonDisabled
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.newFolder)
        ? (_openBlock(), _createBlock("form", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, [
                _createVNode(_component_InputText, {
                  id: "code",
                  class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.newFolder.code.$invalid && _ctx.v$.newFolder.code.$dirty
                        }],
                  type: "text",
                  maxLength: "25",
                  modelValue: _ctx.v$.newFolder.code.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.newFolder.code.$model = $event)),
                  modelModifiers: { trim: true },
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.newFolder.code.$touch()))
                }, null, 8, ["modelValue", "class"]),
                _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.glossary.common.code')) + " * ", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.newFolder.code,
                additionalTranslateParams: {
                        fieldName: _ctx.$t('managers.glossary.common.code')
                    }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_InputText, {
                  id: "name",
                  class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.newFolder.name.$invalid && _ctx.v$.newFolder.name.$dirty
                        }],
                  type: "text",
                  maxLength: "25",
                  modelValue: _ctx.v$.newFolder.name.$model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.newFolder.name.$model = $event)),
                  modelModifiers: { trim: true },
                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.newFolder.name.$touch()))
                }, null, 8, ["modelValue", "class"]),
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('importExport.catalogFunction.column.name')) + " * ", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.newFolder.name,
                additionalTranslateParams: {
                        fieldName: _ctx.$t('importExport.catalogFunction.column.name')
                    }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, [
                _createVNode(_component_InputText, {
                  id: "descr",
                  class: "kn-material-input",
                  type: "text",
                  maxLength: "254",
                  modelValue: _ctx.newFolder.descr,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.newFolder.descr = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.description')), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}